import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowX: "hidden",
  },
  contentWrapper: {
    margin: 16,
  },
  btnWrapper: {
    margin: 10,
    marginTop: 60,
    // marginBottom:30
  },
  btn: {
    textTransform: "capitalize",
    // margin:"0px -10px"
  },
  empty: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    height: "calc(100vh - 186px)",
    fontWeight: "bold",
    fontSize: 15,
  },
}));

export default useStyles;
